import { buttonShuffle } from "../helpers-board.js";
/*
 * Change every button number to a random number */
function randomNumber({ board, buttons, initialPositions }) {
  buttons.forEach((button) => {
    button.innerText = `Click it ${Math.floor(Math.random() * 100)}`
  }
  )
  buttonShuffle({ board, buttons, initialPositions });
}

export default randomNumber;
